var shop_currency_default = $('#shop_currency_val').text();

function myCartSection() {
  var SideContentHeight = $('.cart-side-panel .block-cart-header').height();
  $('#cart_container_id').css('height', $(window).height() - SideContentHeight + 'px');  
}
jQuery(window).resize(function(){
  myCartSection();
});
var shop_currency;
if(typeof $.cookie('currency') === 'undefined'){
  shop_currency = shop_currency_default;
} else{
  shop_currency = $.cookie('currency');
}
var wc_theme_source = {
  lib:{
    ajax_error: function(error, message){
      var data = eval('('+error.responseText+')');
      if (!!data.message) {
        $('#added_product_popup').find('h3').text(data.description);
        $('#added_product_popup').find('.cart_redirect_btn').hide();
        $('#added_product_popup').show("clip", 500);
      }
    },
    on_cart_update: function(item){
      setTimeout(function(){
        $.ajax({
          url:'/cart',
          type:'GET',
          success: function(data){
            //console.log(data);
            var parsed = $.parseHTML(data), 
                result = $(parsed).find(".cartdrawerpro").html();
            if($(result).length > 0){ 
              if(result != null && result != '' && result != undefined){ 
                $('#cartrelated').html(result);
              }
            }
          }
        });

//         var cartlocal = $(".cartdrawerpro").html();
//         localStorage.setItem("upsell", cartlocal);
//         document.getElementById("cartrelated").innerHTML = localStorage.getItem("upsell");
        
        
        
        
        jQuery.getJSON('/cart.js', function(cart) {          
          if(cart.item_count > 0){
            var upsell_html = '';
            $.each(cart.items, function(index, item){
              var cart_handle = item.handle;
              var storage_val = localStorage[cart_handle];                            
              
              if(typeof storage_val != 'undefined'){
                if(storage_val != ''){
                  upsell_html += storage_val;
                }
              }
              //console.log(upsell_html);
              if(index === (cart.items.length - 1)){
                if(upsell_html != ''){
                  $('#wc_cart_drawer_upsell').html(upsell_html);
                } else{
                  $('.upsell_content').attr('style', 'display:none !important;');
                }
              }
            });
          }          
          $('.cart_qty_cls').html(cart.item_count);
          var shipping_price = parseFloat();
          var total_price = Shopify.formatMoney(cart.total_price, shop_currency_default).replace(/[^\d\.]/g, '');
          var remaining_value = parseFloat(shipping_price) - parseFloat(total_price);
          var final_value = remaining_value.toFixed(2);			
          if( final_value < 0 ){   
            $('.free_shipping').css('display','inline-block');
            $('.notFree_shipping').hide();    
          }
          else{    
            $('.remaining_value').text('$'+final_value);
            $('.notFree_shipping').css('display','inline-block');
            $('.free_shipping').hide();   
          }
          
          if(cart.item_count > 0){
            
            var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
            
            if($('.items_carts span').hasClass('money')){
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            } else{
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            }
          } else{
            
            $('.items_carts span').remove();
            $('.items_carts').html("<span class='money'>$0.00</span>");
            
          }
          setTimeout(function(){
            //currenciesCallbackSpecial('.items_carts span.money');
            myCartSection();
          },1000);                   
        });                  
      },100);
      
    },
    on_item_added: function(item){
      //wc_theme_source.lib.on_cart_update(item);
      ajaxCart.load();
    },
    on_product: function(e){
      alert("Received everything we ever wanted to know about " + e.title);
    },
    addtocart_product: function(id, qty, callback){
      var qty = qty || 1;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + qty + "&id=" + id,
        dataType: "json",
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, id);
          } else{
            wc_theme_source.lib.on_item_added(item);
          }
       
          jQuery('#added_product_popup').find('h3').html('<strong>'+ item.title + '</strong> <span>added to your Cart</span>');
          jQuery('#added_product_popup').show("clip", 500);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    get_product: function(handle, callback){
      jQuery.getJSON("/products/" + handle + ".js", function(product, n){
        wc_theme_source.lib.on_product(product);
      });
    },
    get_cart: function(callback){
      jQuery.getJSON("/cart.js", function(cart, textstatus){
        if((typeof callback) === 'function'){
          callback(cart);
        } else{
          wc_theme_source.lib.on_cart_update(cart);         
        }
      });
    },
    addtocart_form: function(form_id, callback, errorCallback){
      var ajax = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery('#' + form_id).serialize(),
        dataType: 'json',
        beforeSend: function(){
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, form_id);
          } else{
            wc_theme_source.lib.on_item_added(item);
          }
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", false);
          jQuery('#added_product_popup').find('h3').html('<strong>'+ item.title + '</strong> <span>added to your Cart</span>');
          jQuery('#added_product_popup').show("clip", 500);
          
        },
        error: function(XMLHttpRequest, textStatus){
          if((typeof errorCallback) === 'function'){
            errorCallback(XMLHttpRequest, textStatus);
          } else{
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        }
      };
      jQuery.ajax(ajax);
    },
    cart_change_item: function(line, qty, callback){
      var ajax = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&line=' + line,
        dataType: 'json',
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_remove_item: function(line, callback){
      var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + line,
        dataType: "json",
        beforeSend: function(){
          jQuery('.cart_loader_cls_id').show();
        },
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          jQuery('.cart_loader_cls_id').hide();
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_clear_all: function(){
      var ajax = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    update_cart_form: function(form){
      var ajax = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + form).serialize(),
        dataType: "json",
        beforeSend: function(){
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    }
  }
}

$(".cart-toggle").on("click" , function(){
   $("body").toggleClass("cart_open");
});
$(document).on('click','.cart-close',function(){
      $("body").removeClass("cart_open");
     // console.log("on click wc-remove")
});

jQuery('body').on('click','.add_to_cart_btn_cls',function(){
  setTimeout(function(){
    $('body').addClass('cart_open');
  },800);
  var temp_form_id = jQuery(this).closest('form').attr('id');
  wc_theme_source.lib.addtocart_form(temp_form_id);
  return false;
});
jQuery(document).on('click', '.cart_add_btn', function(){
  var temp_variant_id = jQuery(this).attr('data-id');
  var temp_qty = 1;
  wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty);

  return false;
});


jQuery('.wishlist_add_btn_cls').click(function(){
  var temp_form_id = jQuery(this).closest('form').attr('id');
  var remove_var = jQuery(this).parents('.cartItem').find('.remove_btn_wislist');
  wc_theme_source.lib.addtocart_form(temp_form_id);
  return false;
});

jQuery('.close_popup_btn_addtocart').click(function(){
  var defalut_text = 'Product added to your Cart';
  jQuery('#added_product_popup').hide("clip", 500);
  setTimeout(function(){
    jQuery('#added_product_popup').find('h3').text(defalut_text);
    jQuery('#added_product_popup').find('.cart_redirect_btn').show();
  },800);
});

// jQuery(document).ready(function(){
//   ajaxCart.load();
// });	
  jQuery(document).ready(function(){
    __optimize.script.after('cart-ajax-script.js', function(){
      ajaxCart.load();
    }, {
      user:{
        interaction:true
      }
    });
  });

$(document).on('click','.addupsell',function(e){
  e.preventDefault(e);
  var varid = $(this).data('id');
  console.log(varid);
  $.ajax({
    type:'POST',
    url:'/cart/add.js',
    dataType:'json',
    data:{id:varid,quantity:1},
    success:function(response) {
      // ajaxCart.load();
        __optimize.script.after('cart-ajax-script.js', function(){
          ajaxCart.load();
        }, {
          user:{
            interaction:true
          }
        });
    }
  });
});


$(document).ready(function(){
  ajaxCart.init();
});


$(document).ready(function() {
  $('.acc-container .acc:nth-child(1) .acc-head').addClass('active');
  $('.acc-container .acc:nth-child(1) .acc-content').slideDown();
  $('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
  });     
});


$(window).scroll(function(){
  var sticky_cart = $('.profuct_stickyCart-wrapper');
  var scroll_section = $(window).scrollTop();
  var section_height = $('.product').height();

  if (scroll_section >= section_height) sticky_cart.addClass('cart_fixed');
  else sticky_cart.removeClass('cart_fixed');
});


$(document).ready(function() {
  function showCart(data_value) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data_value,
      success: function(data) {
        console.log('Success');
        console.log(data);
        // wc_theme_source.lib.on_cart_update(data);
        // $('body').addClass('cart_open');
      },
      error: function(data) {
        console.log('Error');
        console.log(data);
      }
    });
  }
  $('.sticky_product_cart_wrapper .product-form__submit').on('click', function(){
    // var custom_form_id = $(this).parents('.stickyCart').attr('data-id');
    var qunt_id = $(this).parents('.stickyCart').find('.wrapQtyBtn #quantity1').val();
    $('.stickyCart #quantity').prop("value", qunt_id);
    var variant_id = $(this).parents('.stickyCart').find('.color__varient').val();
    console.log(qunt_id,variant_id);
    wc_theme_source.lib.addtocart_product(variant_id, qunt_id);
    setTimeout(function(){
      $('body').addClass('cart_open');
    },800);
    return false;
  });
});



  function productTimer() {
    
    var link = document.querySelector('.soldout_product_wrapper .counter_inner');
    if (link != null) {
      var collection = link.getAttribute('data-timer');
    
      if (collection != null) {
        var collection_value = new Date(collection); 
        collection_value = (Date.parse(collection_value) / 1000); 
        var now = new Date(); 
        now = (Date.parse(now) / 1000); 
        var timeLeft = collection_value - now; 
        var days = Math.floor(timeLeft / 86400); 
        var hours = Math.floor((timeLeft - (days * 86400)) / 3600); 
        var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600)) / 60); 
        var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60))); 
        if (hours < "10") { 
            hours = "0" + hours; 
        } 
        if (minutes < "10") { 
            minutes = "0" + minutes; 
        } 
        if (seconds < "10") { 
            seconds = "0" + seconds; 
        } 
        if (days < "0" || hours < "0" || minutes < "0" || seconds < "0") { 
            $(".soldout_product_wrapper .big-countdown").css("display", "none"); 
        } 
        $(".soldout_product_wrapper .days").html(days + "<span>D</span>"); 
        $(".soldout_product_wrapper .hours").html(hours + "<span>H</span>"); 
        $(".soldout_product_wrapper .minutes").html(minutes + "<span>M</span>"); 
        
        $(".soldout_product_wrapper .seconds").html(seconds + "<span>S</span>"); 
      }
    }
    
  } 
      
  setInterval(function () { productTimer(); }, 1000);

  $(document).ready(function() { 
    if($('.is--cartItems-wrapper .product-dec-box p').attr('data-product-firsttime-cart') != '') {
      var product_cart = $('.is--cartItems-wrapper .product-dec-box p').attr('data-product-firsttime-cart');
      $('.is--cartItems-wrapper .product-dec-box p #odItems').text('0');
      console.log("null");
    }else {
      var product_cart = $(".is--cartItems-wrapper .product-dec-box p").attr('data-product-cart');
      $('.is--cartItems-wrapper .product-dec-box p #odItems').text(product_cart);
      console.log("avialble");
    }
  });

  
